import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/core/interfaces/store';

const userPreferencesSelector = (state: RootState) => state.userPreferences;

export const getArticleClusteringEnabledSelector = createSelector(
  userPreferencesSelector,
  state => state.articleClusteringEnabled
);

export const isArticleClusteringPreferenceLoadedSelector = createSelector(
  userPreferencesSelector,
  state => state.isArticleClusteringPreferenceLoaded
);

export const isArticleClusteringUpdatingSelector = createSelector(
  userPreferencesSelector,
  state => state.isArticleClusteringUpdating
);

export const reportsPreferenceVersionSelector = createSelector(
  userPreferencesSelector,
  state => state.reportsPreferenceVersion
);
